var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheckmark = function SvgCircleCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "currentcolor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-checkmark_svg__clip0_4069_34386)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.751 21.126 12.624 18l-1.065 1.057 4.192 4.193 9-9-1.057-1.058z"
  }))));
};
export { SvgCircleCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgMzYiIGZpbGw9Im5vbmUiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGZpbGw9ImN1cnJlbnRjb2xvciIgY3g9IjE4IiBjeT0iMTgiIHI9IjE1Ii8+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQwNjlfMzQzODYpIj4KICAgIDxwYXRoIGQ9Ik0xNS43NTExIDIxLjEyNjRMMTIuNjIzNiAxNy45OTg5TDExLjU1ODYgMTkuMDU2NEwxNS43NTExIDIzLjI0ODlMMjQuNzUxMSAxNC4yNDg5TDIzLjY5MzYgMTMuMTkxNEwxNS43NTExIDIxLjEyNjRaIiBmaWxsPSJ3aGl0ZSIvPgogIDwvZz4KCjwvc3ZnPgoK";